module.exports = __webpack_public_path__ + "img/BY.171c335c.svg";